module.exports = __webpack_public_path__ + "img/DarkBackground.17329819.png";